import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { refineApi } from '../api'

interface RefineVars {
  file: File
  prompt: string
}

export function useRefineImage(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ file, prompt }: RefineVars) => refineApi.refine(businessId, file, prompt),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
